import FranceTravailRobot from "../components/FranceTravailRobot";
import { mergeFranceTravailProspects } from "../commercial/services/franceTravail.mjs";
import React, { useEffect, useState } from "react";
import { App } from "../commercial/main";
import axios from "../axios/AxiosInstance";
import { apiErrorMessage } from "../utils/apiError";
import { connectClients } from "../commercial/services/liveClients";
import { loadCommercialState, saveCommercialState } from "../services/commercialState";

export default function CommercialPage({ dayContent, headerActionsTarget }) {
  const user = {
    id: localStorage.getItem("userId"),
    name: [localStorage.getItem("firstname"), localStorage.getItem("lastname")].filter(value => value && value !== "undefined").join(" ") || "Mon espace",
    role: "commercial", agency: localStorage.getItem("agencyCity") || localStorage.getItem("agencyName") || "Mon agence",
  };
  const key = `jm-commercial-live:${user.id}:${localStorage.getItem("agencyName")}`;

  const refreshPortfolio = async () => {
    const [{data: clients}, saved, {data: orders}, {data: needs}] = await Promise.all([
      axios.get("client/freelance"), loadCommercialState(), axios.get("order/commercial-history"), axios.get("commercial/france-travail/needs"),
    ]);
    return mergeFranceTravailProspects(connectClients(Array.isArray(clients) ? clients : [], user, saved, Array.isArray(orders) ? orders : []), needs);
  };
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    Promise.all([
      axios.get("client/freelance"),
      loadCommercialState(),
      axios.get("order/commercial-history"), axios.get("commercial/france-travail/needs"),
    ]).then(([{ data: clients }, saved, { data: orders }, { data: needs }]) => {
      if (!active) return;
      setData(
        mergeFranceTravailProspects(connectClients(
          Array.isArray(clients) ? clients : [],
          user,
          saved,
          Array.isArray(orders) ? orders : [],
        ), needs),
      );
    }).catch((error) => { const detail = apiErrorMessage(error, "Impossible de charger votre espace commercial. Actualisez la page pour réessayer."); if (active && detail) setError(detail); });
    return () => { active = false; };
  // The page is remounted when changing agencies.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return <><div className="commercial-module">
    {error ? <p role="alert" className="text-red-700">{error}</p> : !data ? <p>Chargement de vos clients…</p> : !data.clients.length ? <><p className="mb-4">Aucun client disponible pour cette agence. Ajoutez vos premiers prospects.</p><FranceTravailRobot api={axios} onSync={rows => setData(current => mergeFranceTravailProspects(current, rows))} /></> : <App headerActionsTarget={headerActionsTarget} key={key} initialData={data} persistenceKey={key} onPersist={saveCommercialState} onRefresh={refreshPortfolio} currentUser={user} dayContent={dayContent} />}
  </div>
  </>;
}
